export default "__VITE_ASSET__c$pA4JhX__"